import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import styled from "styled-components";
import { Trans } from "../utils/i18n";
import {useInertiaState} from "./Layout";


const ParcelServiceSelect = React.memo(function ({ parcel_services, submitting, form }) {
        return (
            <Grid container spacing={3}>
                {
                    parcel_services
                        .map((item) =>
                            <Grid item xs={12} sm={4} key={item.id}>
                                <Field
                                    name={'parcel_service'}
                                    type={'radio'}
                                    value={item.key}
                                    //placeholder={field.placeholder}
                                    component={RadioButton}
                                    validate={value => (value ? undefined : <Trans i18nKey="common.required">Required</Trans>)}
                                    field={{
                                        titel: item.name,
                                        description: item.description,
                                    }}
                                    disabled={submitting}
                                />
                            </Grid>,
                        )
                }
            </Grid>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default ParcelServiceSelect;
